import SpacePath from "components/SpacePath";
import TagsList from "components/TagsList";
import DescriptionDetails from "components/DescriptionDetails";
import FormFieldTimestamp from "components/FormFields/Timestamp";
import FormFieldViewText from "components/FormFields/ViewText";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import FormField from "ds/components/Form/Field";
import { useShowFullDescriptionWithBackArrow } from "ds/components/FullDescriptionDrawer/useShowFullDescriptionWithBackArrow";
import getIntentProjectRunnerImageTooltip from "shared/IntentProject/getRunnerImageTooltip";
import { IntentProject } from "types/generated";
import WorkerPoolMetaInfoItem from "shared/WorkerPool/MetaInfoItem";

type IntentProjectDetailsDrawerProps = {
  intentProject: IntentProject;
};

const IntentProjectDetailsDrawer = createDrawer(
  ({ intentProject }: IntentProjectDetailsDrawerProps) => {
    const onOpenFullDescription = useShowFullDescriptionWithBackArrow(intentProject.description);

    return (
      <DrawerSimple>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="Intent Project details" />
          <DrawerCloseIcon />
        </DrawerHeader>

        <DrawerBody>
          <FormFieldViewText label="ID" value={intentProject.id} withCopy />
          <FormFieldViewText label="Name" value={intentProject.name} />

          <FormField label="Space">
            <SpacePath
              variant="expandable"
              spaceId={intentProject.space.id}
              fallbackName={intentProject.space.name}
            />
          </FormField>

          <FormField label="Worker pool">
            <WorkerPoolMetaInfoItem workerPool={intentProject.workerPool} />
          </FormField>

          {intentProject.runnerImage !== "" && (
            <FormFieldViewText
              {...getIntentProjectRunnerImageTooltip()}
              label="Runner image"
              value={intentProject.runnerImage}
              withCopy
            />
          )}

          <DescriptionDetails
            description={intentProject.description}
            onOpenFullDescription={onOpenFullDescription}
          />

          <FormFieldTimestamp label="Created at" timestamp={intentProject.createdAt} />

          {intentProject.lastResourcesUpdatedAt && (
            <FormFieldTimestamp
              label="Last resources updated at"
              timestamp={intentProject.lastResourcesUpdatedAt}
            />
          )}

          {intentProject.createdBy && (
            <FormFieldViewText label="Created by" value={intentProject.createdBy} />
          )}

          {intentProject.labels.length > 0 && (
            <FormField label="Labels">
              <TagsList tags={intentProject.labels} alwaysExpanded />
            </FormField>
          )}
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showIntentProjectDetailsDrawer = createDrawerTrigger(IntentProjectDetailsDrawer);
